import { MouseEvent, RefObject } from "react";
import { JustDate } from "../utils/dom";
import ChatBubble from "./chat-bubble";
import shared from "../data/js/shared";
import { ChatMessage } from "../contexts/ChatMessageProvider";

const { newLabel } = shared.chat;

// DateLine component - shows date separator in chat
const DateLine = ({ msg }: { msg: ChatMessage }) => {
  const today = new Date().toJSON().replace("T", " ");
  const inner = JustDate(msg.createdDate) === JustDate(today)
    ? "Today"
    : JustDate(msg.createdDate);
  return <div className="date-line">{inner}</div>;
};

// Message component - renders a single message with optional date line
const Message = ({
  message,
  meId,
  activeMessage,
  setActiveMessage,
  setMessageMenuOpen,
  dateLine,
  onTriggerRef,
}: {
  message: ChatMessage;
  meId: string;
  activeMessage: ChatMessage | null;
  setActiveMessage: (msg: ChatMessage) => void;
  setMessageMenuOpen: (open: boolean) => void;
  dateLine: boolean;
  onTriggerRef?: (ref: RefObject<HTMLDivElement | null>) => void;
}) => {
  const clickForMenu = (e: MouseEvent<HTMLDivElement>) => {
    const t = (e.target as HTMLElement).closest(".msg-cont");
    setActiveMessage(message);
    t?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setMessageMenuOpen(true);
  };

  const output = [];
  if (dateLine) {
    output.push(<DateLine msg={message} key={message.id} />);
  }
  const myId = String(meId) === String(message.userId);
  output.push(
    <ChatBubble
      msg={message}
      meId={meId}
      active={activeMessage?.id === message?.id}
      key={message.id + "msg"}
      onClick={(e: MouseEvent<HTMLDivElement>) => {
        if (myId) clickForMenu(e);
      }}
      onTriggerRef={onTriggerRef}
    />,
  );
  return <div className="msg-cont" data-testid="chat-message">{output}</div>;
};

// Messages component - renders a list of messages with date separators
export const Messages = ({
  messages,
  meId,
  newMessageCount,
  activeMessage,
  setActiveMessage,
  setMessageMenuOpen,
  onTriggerRef,
}: {
  messages: ChatMessage[];
  meId: string;
  newMessageCount: number;
  activeMessage: ChatMessage | null;
  setActiveMessage: (msg: ChatMessage) => void;
  setMessageMenuOpen: (open: boolean) => void;
  onTriggerRef?: (ref: RefObject<HTMLDivElement | null>) => void;
}) => {
  let lastDate = Date.parse("1970-01-01");
  return messages.map((m, i) => {
    const thisDate = Date.parse((m.createdDate ?? "1970-01-01").split(" ")[0]);
    const dateLine = thisDate > lastDate;
    if (dateLine) lastDate = thisDate;
    return messages.length - newMessageCount === i ? (
      <div key={m.id + "-new"}>
        <div className="newMessageLine">{newLabel}</div>
        <Message
          message={m}
          meId={meId}
          dateLine={dateLine}
          activeMessage={activeMessage}
          setActiveMessage={setActiveMessage}
          setMessageMenuOpen={setMessageMenuOpen}
          onTriggerRef={onTriggerRef}
        />
      </div>
    ) : (
      <Message
        message={m}
        key={m.id}
        meId={meId}
        dateLine={dateLine}
        activeMessage={activeMessage}
        setActiveMessage={setActiveMessage}
        setMessageMenuOpen={setMessageMenuOpen}
        onTriggerRef={onTriggerRef}
      />
    );
  });
};

export default Messages;